import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface SeoHeadProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  noindex?: boolean;
}

const SITE_URL = 'https://www.coderom.com';

const SeoHead: React.FC<SeoHeadProps> = ({
  title,
  description,
  canonical,
  ogImage = '/images/og-image.png',
  noindex = false,
}) => {
  const { pathname } = useLocation();
  const canonicalUrl = canonical || `${SITE_URL}${pathname === '/' ? '' : pathname}`;
  const fullOgImage = ogImage.startsWith('http') ? ogImage : `${SITE_URL}${ogImage}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:type" content="website" />
      <meta name="twitter:site" content="@coderomapp" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};

export default SeoHead;
